// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bahesu3{justify-content:flex-end}\n._1e0c1txw{display:flex}\n._2hwx1wug{margin-right:auto}\n._ca0qpxbi{padding-top:var(--ds-space-200,1pc)}", ""]);
// Exports
module.exports = exports;
